/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Event_Groups_LabelInputs */

const en_metadata_merge_event_groups_label = /** @type {(inputs: Metadata_Merge_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Event Groups`)
};

const fr_metadata_merge_event_groups_label = /** @type {(inputs: Metadata_Merge_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner les groupes d'événements`)
};

const de_metadata_merge_event_groups_label = /** @type {(inputs: Metadata_Merge_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppen auswählen`)
};

const it_metadata_merge_event_groups_label = /** @type {(inputs: Metadata_Merge_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona i gruppi di eventi`)
};

const ru_metadata_merge_event_groups_label = /** @type {(inputs: Metadata_Merge_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группы мероприятий`)
};

const es_metadata_merge_event_groups_label = /** @type {(inputs: Metadata_Merge_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar grupos de eventos`)
};

const zh_cn2_metadata_merge_event_groups_label = /** @type {(inputs: Metadata_Merge_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择活动组`)
};

const ja_metadata_merge_event_groups_label = /** @type {(inputs: Metadata_Merge_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループを選択`)
};

const hi_metadata_merge_event_groups_label = /** @type {(inputs: Metadata_Merge_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह चुनें`)
};

const pt_pt2_metadata_merge_event_groups_label = /** @type {(inputs: Metadata_Merge_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar grupos de eventos`)
};

/**
* | output |
* | --- |
* | "Select Event Groups" |
*
* @param {Metadata_Merge_Event_Groups_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_event_groups_label = /** @type {((inputs?: Metadata_Merge_Event_Groups_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Event_Groups_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_event_groups_label(inputs)
	if (locale === "de") return de_metadata_merge_event_groups_label(inputs)
	if (locale === "it") return it_metadata_merge_event_groups_label(inputs)
	if (locale === "ru") return ru_metadata_merge_event_groups_label(inputs)
	if (locale === "es") return es_metadata_merge_event_groups_label(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_event_groups_label(inputs)
	if (locale === "ja") return ja_metadata_merge_event_groups_label(inputs)
	if (locale === "hi") return hi_metadata_merge_event_groups_label(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_event_groups_label(inputs)
	return en_metadata_merge_event_groups_label(inputs)
});